// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"119":"6e91e587","235":"9800652e","815":"4b86fba1"}[chunkId] + ".chunk.css";
};